var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 60.708,
    y1: 402.847,
    x2: 394.65,
    y2: 68.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4158d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c850c0"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M486.411,213.742H443.524V140.8a7.2,7.2,0,0,0-7.2-7.2h-52.9V60.658a7.2,7.2,0,0,0-7.2-7.2H65.119c-25.446-.653-47.982,22.533-46.708,47.847,0,244.147.1,227.068,0,239.183-.1,26.392,21.151,47.938,47.268,47.932H98.549v23.751a7.206,7.206,0,0,0,4.578,6.708L203.3,458.05a7.622,7.622,0,0,0,5.245,0L308.72,418.879a7.206,7.206,0,0,0,4.578-6.708V388.42H436.324a7.2,7.2,0,0,0,7.2-7.2V298.258h42.887a7.2,7.2,0,0,0,7.2-7.2V220.942A7.2,7.2,0,0,0,486.411,213.742ZM65.056,67.858H369.02V133.6H65.109a32.38,32.38,0,0,1-32.3-32.5C31.926,83.472,47.4,67.474,65.056,67.858ZM222.849,293.441l-16.925,6.617c-10.964-4.286-69.828-27.3-82.058-32.086l82.058-39.056,82.057,39.056Zm-109.9-14.271,85.775,33.54V440.8l-85.775-33.539ZM298.9,407.256,213.124,440.8V312.71L298.9,279.17ZM429.124,374.02H313.3v-105.4a7.466,7.466,0,0,0-4.107-6.5L209.017,214.438a7.223,7.223,0,0,0-6.187,0c-.346.455-100.284,47.438-100.534,47.921a7.243,7.243,0,0,0-3.747,6.262v105.4H65.682c-18.127,0-32.871-14.97-32.871-33.371h-.057c.143,3.614.01-173.454.037-205.716A46.5,46.5,0,0,0,65.109,148H429.124v65.742h-21.98c-22.113,0-40.106,17.993-40.075,39.417-2.651,23.133,16.3,45.581,39.815,45.1h22.24Zm50.087-90.162H406.933c-15.586.155-27.28-14.39-25.5-30.01a25.734,25.734,0,0,1,25.706-25.706h72.067Z",
    fill: "#ffffff",
    "data-original": "#000000"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bcad6b6eab124325dd1cf638e29dc53c.svg";
export { ForwardRef as ReactComponent };